var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"x-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}},[_c('path',{attrs:{"d":"m9.667 1.273-.94-.94L5 4.06 1.274.333l-.94.94L4.06 5 .333 8.727l.94.94L5 5.94l3.727 3.727.94-.94L5.94 5l3.727-3.727Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }